import { Component } from '@angular/core';

@Component({
  selector: 'app-search',
  styleUrls: ['./center.style.css'],
  template: `
    <div class="center">

    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M14.0611 12.8047C15.0666 11.5285 15.6665 9.91781 15.6665 8.16699C15.6665 4.02486 12.3086 0.666992 8.1665 0.666992C4.02437 0.666992 0.666504 4.02486 0.666504 8.16699C0.666504 12.3091 4.02437 15.667 8.1665 15.667C9.91733 15.667 11.528 15.0671 12.8043 14.0616L15.8161 17.0734C16.1631 17.4204 16.7258 17.4204 17.0729 17.0734C17.4199 16.7263 17.4199 16.1636 17.0729 15.8165L14.0611 12.8047ZM13.9018 8.16699C13.9018 11.3345 11.334 13.9023 8.1665 13.9023C4.99899 13.9023 2.43121 11.3345 2.43121 8.16699C2.43121 4.99948 4.99899 2.4317 8.1665 2.4317C11.334 2.4317 13.9018 4.99948 13.9018 8.16699Z" fill="white" fillOpacity="0.8"/>
    </svg>
  
    </div>`
})
export class SearchComponent {}
